$('form').submit(false);

var items = [];

// return the index of variant in 'items' array
var checkArray = (variantId) => {
  return items.findIndex( (element, index, array) => {
    return element.id == variantId
  });
}

var setQuantity = function(val, variantId) {
  let index = checkArray(variantId);
  if (index !== -1) {
    items[index].quantity = val
  }
  else if (index === -1 ) {
    items.push({
      quantity: val,
      id: variantId,
      properties: {
        'Monogram': ''
      }
    })
  }
}

var setMonogram = function(monogram, variantId) {
  let index = checkArray(variantId);
  if (index !== -1) {
    items[index].properties['Monogram'] = monogram
  }
  else if (index === -1 ) {
    items.push({
      quantity: 0,
      id: variantId,
      properties: {
        'Monogram': monogram
      }
    })
  }
}  


var addToCart = function(variantId) {
  let obj = {};
  let index = checkArray(variantId);

  if (index !== -1) {
    obj = items[index];
    if (obj.quantity > 0 && obj.properties['Monogram'] !== '') {
      // using AXIOS for calls- a promise based http client
      axios.post('/cart/add.js', obj)
      .then(function (response) {
        jQuery.getJSON('/cart.js', function(cart) {
          $('span.cart-count').removeClass('hidden-count')
          $('.cart-count').html(cart.item_count);
          console.log('cart contents', cart);
        });
      })
      .catch(function (error) {
        alert("addToCart: ERROR", error);
      });
    }
  }      
}  

var addAllToCart = function() {
  if (items.length) {
    var request = items.shift();
    axios.post('/cart/add.js', request)
    .then(function (response) {
      addAllToCart();
    })
    .catch(function (error) {
      alert("addToCart: ERROR", error);
    });
  }
  else {
    jQuery.getJSON('/cart.js', function(cart) {
      $('span.cart-count').removeClass('hidden-count')
      $('.cart-count').html(cart.item_count);
      console.log('cart contents', cart);
    });
    $('.inputOrderQuantity').val('');      
  }
}   

var updateCart = function(variantId) {
  let index = checkArray(variantId);
  var key = variantId;
  var obj = {updates: {}};

  if (index !== -1) {
    obj.updates[key] = items[index].quantity;
    axios.post('/cart/update.js', obj)
    .then(function (response) {
      jQuery.getJSON('/cart.js', function(cart) {
        $('.cart-count').html(cart.item_count);
        console.log('cart contents', cart);           
      });             
    })
    .catch(function (error) {
      alert("updateCart: ERROR", error);
    });
  }
}

var getCart = function() {
  return axios.get('/cart.js')
  .then(function (response) {
    return response.data; 
  })
  .catch(function (error) {
    console.log('getCart: ERROR', error);
  });      
}

var getInfo = function(value) {
  axios.get('/products/'+ value + '.js')
  .then(function (response) {
    console.log("getInfo: ", response.data);
  })
  .catch(function (error) {
    console.log('getInfo: ERROR', error);
  });      
} 

